import React, { useEffect, useState, useRef  } from "react";
import { Row, Col, Card, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Breadcrumbs from "../../../../shared/components/Breadcrumbs";
import { TICKETING, TICKET_DETAILS, SEND, BACKTOLIST } from "../../../../shared/constants/Constants";
import DefaultButton from "../../../../shared/components/DefaultButton";
import TicketGeneral from "./TicketGeneral";
import TicketMessages from "./TicketMessages";
import TicketSolution from "./TicketSolution";
import TicketHistory from "./TicketHistory";
import TicketArticle from "./TicketArticle";
import FormikSelectField from "../../../../shared/components/FormikSelectField";
import { loadActiveEmployeeDataRequest } from "../../../employees/redux/Actions";
import { loadStatusDropdownRequest } from "../../../vision_hub/escalation_rule_builder/redux/Actions";
import {loadGroupByTypeAdminGetDataRequest,loadGroupByIDJobTitlesGetDataRequest,} from "../../../group_jobtitles/redux/Actions";
import { loadTicketListGetDataRequest, loadTicketDetailsGetDataRequest, loadTicketMessageAddDataRequest, loadTicketDetailsAddDataRequest, loadTicketInsightDetailsGetDataRequest, loadTicketDeleteDataRequest, loadTicketAttachmentDeleteDataRequest  } from "../redux/Actions";
import { loadCategorySubCategoryConfigDataRequest } from "../../../vision_hub/categories/redux/Actions";
import TicketSendMessage from "./TicketSendMessage";
import Modalpopup from "../../../../shared/components/Modalpopup";
import ConfirmModal from "../../../../shared/components/ConfirmModal";
import { PrevNextButtons } from "../../../../shared/components/PrevNextButtons";
import { useFormikContext } from "formik";
import { usePrompt } from "./usePrompt";
import ReopenReasonModal from "./ReopenReasonModal";
import TicketInsights from "./TicketInsights";
import "./Ticketing.css";
import { loadAdminTicketsQueryRequest } from "../redux/Actions";
import { setNextPrevIds } from "../../../next_prev_redux/Actions";

const TicketDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let params = useParams();
  const { adminGroup, group } = useSelector((store) => store.groupJobtitle);
  const {ticketdetails, error, loading, insights, ticketDeleteSuccess} = useSelector((store) => store.ticketing);
  const { categoryconfig } = useSelector((store) => store.categories); 
  const { statusList, loadingStatus } = useSelector(state => state.ticketingDropdowns); 
  const [currentTracker, setCurrentTracker] = useState(1);
  const [employees, setEmployees] = useState([]);
  const [showSendModal, setShowSendModal] = useState(false);
  const emp_no = JSON.parse(localStorage.getItem("emp_no"));
  const employee = JSON.parse(localStorage.getItem("employee"));
  //let emp_name = [employee.first_name, employee.last_name,employee.emp_no,].filter(Boolean).join(", ");
  let emp_name = employee ? [employee.first_name, employee.last_name, employee.emp_no].filter(Boolean).join(", ")  : "";  // Returns empty string if employee is null
  console.log("Employee",emp_name);
  const [newMessageAttachments, setNewMessageAttachments] = useState([]);  
  const originalValuesRef = useRef(null);
  const [isChanged, setIsChanged] = useState(false);
  const [shouldReload, setShouldReload] = useState(false);
  const [articleID, setArticleID] = useState( ticketdetails?.category_config_id || "");
  const firstSolution = Array.isArray(ticketdetails?.solutions) ? ticketdetails.solutions[0] : ticketdetails?.solutions;
  const lastNotes = Array.isArray(ticketdetails?.internal_notes) ? ticketdetails.internal_notes[ticketdetails.internal_notes.length - 1] : ticketdetails?.internal_notes;  const formikRef = useRef();
  const [showReopenReasonModal, setShowReopenReasonModal] = useState(false);
  const [reopenReason, setReopenReason] = useState("");
  const [pendingStatusChange, setPendingStatusChange] = useState(null);
  const previousStatusRef = useRef(null);
  const [showSidePanel, setShowSidePanel] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const sendMessageFormikRef = useRef(null);
  const [submitAction, setSubmitAction] = useState("apply"); 
  const [bypassPrompt, setBypassPrompt] = useState(false);
  const canDelete = ["363647","135205", "134321"].includes(String(emp_no));
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const { queryData } = useSelector(store => store.adminTickets);
  const { ids: nextPrevIds } = useSelector(state => state.nextPrev);
  const [filteredCategories, setFilteredCategories] = useState([]);

  //  If no IDs in store fetch the list
  useEffect(() => {
    const existingIds = nextPrevIds?.[TICKETING];
    if (!existingIds || existingIds.length === 0) {
      dispatch(loadAdminTicketsQueryRequest({
        filter: {},
        page: 1,
        sort: null,
        pageSize: 80,
        defaultFilter: null,
      }));
    }
  }, []);

  //  When queryData arrives, populate nextPrevIds
  useEffect(() => {
    if (queryData?.length) {
      const idObjects = queryData.map(item => ({
        id: item.id,
        type: item.ticket_type,
      }));
      dispatch(setNextPrevIds(idObjects, TICKETING));
    }
  }, [queryData]);


  console.log("FirstNotes",lastNotes);
  console.log("Employee",categoryconfig);   

  
  useEffect(() => {
    dispatch(loadActiveEmployeeDataRequest());
    dispatch(loadGroupByTypeAdminGetDataRequest("admin"));
    dispatch(loadTicketDetailsGetDataRequest(params.id));
    dispatch(loadCategorySubCategoryConfigDataRequest());
    dispatch(loadStatusDropdownRequest());
    dispatch(loadTicketInsightDetailsGetDataRequest(params.id));
  }, [dispatch,params.id]);

  // Filter categories based on user's company
  useEffect(() => {
    if (categoryconfig?.data && Array.isArray(categoryconfig.data) && ticketdetails?.company_id) {
      const userCompanyId = ticketdetails.company_id;

      const filtered = categoryconfig.data.filter((category) => {
        // Check if category has at least one subcategory matching the user's company
        return (category.sub_category || []).some(
          (sc) => Number(sc.company_id) === Number(userCompanyId)
        );
      }).map((category) => ({
        ...category,
        // Filter subcategories to only show those matching the user's company
        sub_category: (category.sub_category || []).filter(
          (sc) => Number(sc.company_id) === Number(userCompanyId)
        )
      }));

      console.log("Filtering categories for company_id:", userCompanyId);
      console.log("Total categories:", categoryconfig.data.length, "Filtered categories:", filtered.length);
      setFilteredCategories(filtered);
    } else if (categoryconfig?.data && Array.isArray(categoryconfig.data)) {
      // If no company_id, show all categories
      console.log("No company_id found, showing all categories");
      setFilteredCategories(categoryconfig.data);
    }
  }, [categoryconfig, ticketdetails?.company_id]);


  useEffect(() => {
    if (group && group.length > 0) {
      setEmployees(group);
    }
  }, [group]);

  const handleAdminGroupChange = (e, setFieldValue) => {
    setFieldValue("assignedTo", null);
    const selectedGroupId = e.target.value;
    setFieldValue("adminGroup", selectedGroupId);
    dispatch(loadGroupByIDJobTitlesGetDataRequest(selectedGroupId));
  };

  useEffect(() => {
    // If we have admin group and no assigned_to, fetch employees for that group
    if (
      ticketdetails?.assigned_to_admin_group 
     // &&  !ticketdetails?.assigned_to
    ) {
      dispatch(loadGroupByIDJobTitlesGetDataRequest(ticketdetails.assigned_to_admin_group));
    }
  }, [ticketdetails, dispatch]);


  const [formInitialValues, setFormInitialValues] = useState({
      
      status: "",
      adminGroup: "",
      assignedTo: "",      
      requestedUser: "",
      category: "",
      subcategory: "",
      categoryConfigId: "",
      internal_notes: "",
      location: { sap: "", district: "", region: "", company: "" },
      ticket: { cc: "", summary: "", description: "", attachments: [] },
      solution: {resolution_type: "",solution_text: "" , cost: ""}
    });
  const [sendMessageInitialValues, setSendMessageInitialValues] = useState({
          method: "both",
          body: "",
          from_email: "",
          body_html: "",
          to_emp_id:"",   
          cc: [],        
          subject: "",
          ticket_id: "",
          attachments: "",
          message_type: "comment",
          from_emp_id: "",
          to_email: "",
          from_employee_id: "",
          to_employee_id: "",
          ticket_number: "",
        });

    useEffect(() => {
      if (ticketdetails) {
        const initial = {
          status: ticketdetails.status_id || "",
          adminGroup: ticketdetails.assigned_to_admin_group || "",
          assignedTo: ticketdetails.assigned_to || "",
          requestedUser: ticketdetails.requested_for_name || "",
          category: ticketdetails.category_name || "",
          subcategory: ticketdetails.sub_category_name || "",
          categoryConfigId: ticketdetails.category_config_id || "",
          internal_notes:  "",
          location: {
            sap: ticketdetails.store_name || "",
            district: ticketdetails.market_name || "",
            region: ticketdetails.region_name || "",
            company: ticketdetails?.company_name || "",
          },
          ticket: {
            summary: ticketdetails.title || "",
            description: ticketdetails.description || "",
            attachments: [],
          },
          solution: {
            resolution_type: firstSolution?.resolution_type || "fixed",
            solution_text: firstSolution?.solution_text || "",
            cost: firstSolution?.cost || ""
          }

        };

        setFormInitialValues(initial);
        originalValuesRef.current = JSON.parse(JSON.stringify(initial));
        previousStatusRef.current = ticketdetails.status_id;

      }
    }, [ticketdetails]);


    const extractEmployeeId = (requestedForName) => {
      if (!requestedForName) return "";
      const parts = requestedForName.split(",");
      return parts.length > 1 ? parts[1].trim() : "";
    };

    useEffect(() => {
        if (ticketdetails) {
          const empId = extractEmployeeId(ticketdetails.requested_for_name);

          // Get CC recipients from the last message
          let lastMessageCC = [];
          if (ticketdetails.messages && ticketdetails.messages.length > 0) {
            // Sort messages by updated_at to get the most recent one
            const sortedMessages = [...ticketdetails.messages].sort(
              (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
            );
            const lastMessage = sortedMessages[0];

            // Parse CC recipients from the last message
            if (lastMessage.cc_recipients) {
              try {
                let recipients = lastMessage.cc_recipients;

                // If it's a string, try to parse it
                if (typeof recipients === 'string') {
                  try {
                    recipients = JSON.parse(recipients);
                  } catch (e) {
                    // If parsing fails, it might be a simple string format
                    recipients = [];
                  }
                }

                // Ensure it's an array
                if (!Array.isArray(recipients)) {
                  recipients = [recipients];
                }

                // Extract employee database IDs from the recipients
                // Backend sends: { id: db_id, employee_id: emp_number, name: "First Last", email: "email@domain.com" }
                lastMessageCC = recipients
                  .map(recipient => {
                    if (typeof recipient === 'object' && recipient !== null) {
                      // Use the 'id' field which contains the employee's database primary key
                      return recipient.id;
                    }
                    return null;
                  })
                  .filter(id => id !== null && id !== undefined);

                console.log("Auto-populated CC recipients from last message:", lastMessageCC);

              } catch (error) {
                console.error("Error parsing CC recipients:", error);
                lastMessageCC = [];
              }
            }
          }

          setSendMessageInitialValues({
            method: "both",
            body: "",
            //from_email: employee.email_work,
            body_html: "",
            to_emp_id: ticketdetails.requested_for_name,
            // from: emp_no || "",
            //to: ticketdetails.requested_for_emp_no || ticketdetails.requested_for_name || "",
            cc: lastMessageCC,
            subject: `${ticketdetails.ticket_number || ""} - ${ticketdetails.title || ""}`,
            ticket_id: ticketdetails.id,
            attachments: "",
            message_type: "comment",
            from_emp_id: emp_name,
            to_email: ticketdetails.requestor_for_email,
            from_employee_id: employee.id,
            to_employee_id: ticketdetails.requested_for,
            ticket_number: ticketdetails.id,
          });
        }
      }, [ticketdetails, emp_no]);

  const validationSchema = Yup.object({
    adminGroup: Yup.string().required("Admin group is required"),
    assignedTo: Yup.string().nullable().when("status", (status, schema) => {
                const selectedStatus = statusList.find(s => s.value === status);
                const isClosed =
                  selectedStatus?.label?.toLowerCase() === "closed" ||
                  selectedStatus?.code?.toLowerCase() === "closed";
                return isClosed
                  ? schema.required("Assignee is required when ticket is Closed")
                  : schema.nullable();
              }),
    category: Yup.string().required("Category is required"),
    subcategory: Yup.string().required("SubCategory is required"),
  });


  const sendMessageValidationSchema = Yup.object({
    method: Yup.string().required("Method is required"),
    body: Yup.string()
      .required("Message cannot be empty")
      .test('not-empty-html', 'Message cannot be empty', (value) => {
        if (!value) return false;
        // Strip HTML tags to check if there's actual content
        const stripped = value.replace(/<[^>]*>/g, '').trim();
        return stripped.length > 0;
      }),
    // from_emp_id: Yup.string().required("From is required"),
    // to_emp_id: Yup.string().required("To is required"),
    // subject: Yup.string().required("Subject is required"),
  });

  const stripHtml = (html) => {
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};

  const getChangedValues = (current, original) => {
  let changed = {};
  console.log("Current,orginal",current,original); 
  for (let key in current) {
    if (typeof current[key] === "object" && current[key] !== null) {
      const nested = getChangedValues(current[key], original[key] || {});
      if (Object.keys(nested).length > 0) {
        changed[key] = nested;
      }
    } else {
      const curr = String(current[key] ?? "");
      const orig = String(original[key] ?? "");

      // If the key is description, strip HTML for comparison
      const currClean = key === "description" ? stripHtml(curr) : curr;
      const origClean = key === "description" ? stripHtml(orig) : orig;

      if (currClean !== origClean) {
          changed[key] = current[key];
      }

    }}
  return changed;
};

// const stripHtml = (html) => {
//   const tmp = document.createElement("div");
//   tmp.innerHTML = html;
//   return tmp.textContent || tmp.innerText || "";
// };

const isImageOnlyContent = (html) => {
  const div = document.createElement("div");
  div.innerHTML = html.trim();
  return Array.from(div.childNodes).every(node => {
    return (node.nodeName === "IMG") || 
           (node.nodeName === "P" && node.querySelectorAll('img').length > 0) ||
           (node.nodeType === 3 && node.textContent.trim() === '');
  });
};

const prepareSendMessagePayload = (values) => {
  const blogMode = isImageOnlyContent(values.body);
  return {
    method: values.method,
    subject: values.subject || (blogMode ? "Blog Post" : ""),
    body_html: values.body,
    body: values.body,
    message_type: "comment",
    to_emp_id: ticketdetails.requestor_for_emp_id,
    from_emp_id: emp_no,
    attachments: values.attachments || [],
    ticket_id: values.ticket_id,
    from_employee_id: employee.id,
    to_employee_id: ticketdetails.requested_for,
    from_email: employee.email_work,
    to_email: ticketdetails.requestor_for_email,
    cc: Array.isArray(values.cc) ? values.cc : [],

  };
};


  const handleSendMessage = (values) => {
  console.log("SEND MESSAGE VALUES:", values);
  // Create FormData
  const payload = prepareSendMessagePayload(values);

  let formData = new FormData();
  Object.keys(payload).forEach(key => {
    if (key === "attachments" && payload.attachments.length > 0) {
      payload.attachments.forEach(file => formData.append("attachments", file));
    } else if (key === "cc") {
      // Handle cc as array - append each employee ID separately
      if (Array.isArray(payload.cc) && payload.cc.length > 0) {
        payload.cc.forEach(employeeId => formData.append("cc[]", employeeId));
      }
    } else {
      formData.append(key, payload[key]);
    }
  });

  // formData.append("to_employee_id", "27341")
  // formData.append("from_employee_id", "28656")
  formData.append("ticket_number", ticketdetails.ticket_number)


  console.log("FORMDATA ENTRIES:");
  for (let p of formData.entries()) {
    console.log(p[0], p[1]);
  }


  console.log("Hello", formData);
  // Send FormData to API
  dispatch(loadTicketMessageAddDataRequest(formData));

  // REFRESH MESSAGES AFTER SEND
  setTimeout(() => {
    dispatch(loadTicketDetailsGetDataRequest(params.id));
  }, 250);

  setShowSendModal(false);
};

  const handleSubmit = (values, { setErrors }) => {
    const selectedStatus = statusList.find(s => s.value === values.status);

    const isClosed =
      selectedStatus?.label?.toLowerCase() === "closed" ||
      selectedStatus?.code?.toLowerCase() === "closed";

    // Check BOTH Formik values AND existing solution
    const isSolutionMissing =
    !values.solution?.resolution_type?.trim() ||
    !values.solution?.solution_text?.trim();

    if (isClosed && isSolutionMissing) {
      // Switch to solution tab and show validation error
      setCurrentTracker(4); // 4 is the SOLUTION tab
      setErrors({
        solution: {
          solution_text: "Solution is required for closed tickets"
        }
      });
      return;
    }

  // continue submit logic...
    const original = originalValuesRef.current;
    const changedValues = getChangedValues(values, original);
    console.log("FINAL PAYLOAD (ONLY CHANGES):", changedValues);

    // Inject config_id
    if (values.category_config_id) {
        changedValues.category_config_id = values.category_config_id;
    }

    // Remove category + subcategory IDs from payload
    delete changedValues.category;
    delete changedValues.subcategory;

    // Include reopen_reason if status changed from closed to new
    if (reopenReason) {
      changedValues.reopen_reason = reopenReason;
    }

    let request = {
       id: ticketdetails.id,
        data: changedValues
    };

    dispatch(loadTicketDetailsAddDataRequest(request));
    if (submitAction === "apply") {
      setBypassPrompt(true);        // disable prompt
      setShouldReload(true);        // stay on page
    }

    if (submitAction === "save") {
      setBypassPrompt(true);
      originalValuesRef.current = JSON.parse(JSON.stringify(values));
      setIsChanged(false);

      navigate("/ticketing");
    }

    setSubmitAction("apply");
    setReopenReason("");
};

//Reset bypass after reload
  useEffect(() => {
    if (shouldReload && !loading) {
      dispatch(loadTicketDetailsGetDataRequest(params.id));
      previousStatusRef.current = formikRef.current?.values.status;
      setShouldReload(false);
      setBypassPrompt(false);   // re-enable prompt
    }
  }, [loading, shouldReload]);

//Reload page after request processed
  // useEffect(() => {
  //   if (shouldReload && !loading) {
  //     dispatch(loadTicketDetailsGetDataRequest(params.id));
  //     previousStatusRef.current = formikRef.current?.values.status;
  //     setShouldReload(false)
  //   }
  // }, [loading, shouldReload])

  
  const checkIfChanged = (current, original) => {
    const changed = getChangedValues(current, original);
    return Object.keys(changed).length > 0;
  };

  // Helper function to check if status change is from closed to new
  const isReopeningTicket = (previousStatus, newStatus) => {
    // Find status objects from statusList
    const prevStatusObj = statusList.find(s => s.value === previousStatus);
    const newStatusObj = statusList.find(s => s.value === newStatus);

    // Check if changing from closed to new (case insensitive)
    const isFromClosed = prevStatusObj?.label?.toLowerCase() === 'closed' ||
                         prevStatusObj?.code?.toLowerCase() === 'closed';
    const isToNew = newStatusObj?.label?.toLowerCase() === 'new' ||
                    newStatusObj?.code?.toLowerCase() === 'new';

    return isFromClosed && isToNew;
  };

  // Handle status change - check if reopening and show modal
  const handleStatusChange = (setFieldValue, newStatusValue) => {
    const previousStatus = previousStatusRef.current;

    if (isReopeningTicket(previousStatus, newStatusValue)) {
      // Store the pending status change
      setPendingStatusChange(newStatusValue);
      setShowReopenReasonModal(true);
    } else {
      // Normal status change
      setFieldValue("status", newStatusValue);
      //previousStatusRef.current = newStatusValue;

      // No longer showing solution modal on status change
      // Validation will handle missing solution when save is clicked
    }
  };

  // Handle confirmation of reopen reason
  const handleReopenReasonConfirm = (reason) => {
    setReopenReason(reason);
    setShowReopenReasonModal(false);

    // Apply the pending status change
    if (pendingStatusChange !== null && formikRef.current) {
      formikRef.current.setFieldValue("status", pendingStatusChange);
      previousStatusRef.current = pendingStatusChange;
      setPendingStatusChange(null);
    }
  };

  // Handle cancel of reopen reason modal
  const handleReopenReasonCancel = () => {
    setShowReopenReasonModal(false);
    setPendingStatusChange(null);
    // Status doesn't change, stays at previous value
  };

  useEffect(() => {
    if (ticketdetails?.category_config_id) {
      setArticleID(ticketdetails.category_config_id);
    }
  }, [ticketdetails]);

  const { showPrompt, confirmNavigation, cancelNavigation } = usePrompt(
    "You have unsaved changes. Are you sure you want to leave?",
    isChanged && !bypassPrompt,
    true
  );
  
  // Add native browser alert for refresh/close
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isChanged && !bypassPrompt) {
        e.preventDefault();
        e.returnValue = ""; // Required for Chrome
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [isChanged, bypassPrompt]);


  // const handleAddSolution = (data) => {
  //   setFieldValue("solution", data);
  // };

  // Delete Ticket
  const handleDeleteTicket = () => {
    setShowDeleteModal(true);
  };

  const confirmDeleteTicket = () => {
    if (!ticketdetails?.id) return;

    dispatch(loadTicketDeleteDataRequest(ticketdetails.id));
    setShowDeleteModal(false);

  };
  
  // after delete
    useEffect(() => {
    if (ticketDeleteSuccess) {
      navigate("/ticketing");

      // If PrevNextButtons already knows next ticket
      // if (nextId) {
      //   navigate(`/ticketing/${nextId}`);
      // } else {
      //   navigate("/ticketing");
      // }

    }
  }, [ticketDeleteSuccess]);
  // What is the actual string value of TICKETING?
console.log("TICKETING constant:", TICKETING);





  return (
    <>
      <Row className="detailsPageHeader align-items-center">
        <Col className="d-flex justify-content-between align-items-center">

          {/* LEFT SIDE - Breadcrumb */}
          <div className="breadcrumb-wrapper">
            <Breadcrumbs
              children={[
                { href: "/ticketing/", label: TICKETING },
                {
                  href: `/ticketing/${params.id}`,
                  label:
                    ticketdetails?.ticket_number && ticketdetails?.title
                      ? `${ticketdetails.ticket_number} - ${ticketdetails.title}`
                      : TICKET_DETAILS,
                },
              ]}
            />
          </div>

          {/* RIGHT SIDE - Buttons */}
          <div className="d-flex align-items-center gap-2 header-actions">
            <PrevNextButtons currentId={params.id} name={TICKETING} />
            <Link to="/ticketing/">
              <DefaultButton
                buttonClass="default-btn-color"
                buttonTitle={BACKTOLIST}
              />
            </Link>
          </div>

        </Col>
      </Row>
      <div className="ticket-header">          
        <Card className="ticket-info-card shadow-sm">
          <Card.Body>
            <Formik
              initialValues={formInitialValues}
              enableReinitialize
              innerRef={formikRef}
              validationSchema={validationSchema}
              onSubmit={(values, { resetForm, setErrors }) => handleSubmit(values, { resetForm, setErrors })}
            >
              {({ values, setFieldValue, errors, touched, resetForm }) => {
                const hasChanged = originalValuesRef.current ? checkIfChanged(values, originalValuesRef.current) : false;
                if (hasChanged !== isChanged) { setIsChanged(hasChanged); }
                return(
                <Form>

                  {/* Tabs + Buttons Row */}
                  <Row className="align-items-center mb-2 ticket-tab-hdr">
                    <Col className="d-flex flex-wrap">
                      {["GENERAL", "MESSAGES", "HISTORY", "SOLUTION" , "ARTICLE"].map((tab, index) => (
                        <button
                          key={index}
                          type="button"
                          className={`ticket-tab ${currentTracker === index + 1 ? "selected" : ""}`}
                          onClick={() => setCurrentTracker(index + 1)}
                          // style={{color: "#ff7f0e"}}
                        >
                          {tab}
                        </button>
                      ))}
                    </Col>

                    <Col className="d-flex justify-content-end gap-1">
                      <DefaultButton
                        buttonClass="btn btn-secondary"
                        buttonTitle="Cancel"
                        buttonType="button"
                        actionBlock={() => resetForm()}
                      />
                      <DefaultButton
                        buttonClass="default-btn-color"
                        buttonTitle="Apply"
                        buttonType="submit"
                        disabled={!isChanged}
                        actionBlock={() => setSubmitAction("apply")}
                      />

                      <DefaultButton
                        buttonClass="default-btn-color"
                        buttonTitle="Save"
                        buttonType="submit"
                        disabled={!isChanged}
                        actionBlock={() => setSubmitAction("save")}
                      /> 
                                          
                      <DefaultButton 
                         buttonClass='default-btn-color' 
                         buttonTitle={SEND} 
                         buttonType="button"
                         actionBlock={() => { setShowSendModal(true); setIsMinimized(false); }}
                      />        
                      {canDelete && (
                        <DefaultButton
                          buttonClass="btn btn-danger"
                          buttonTitle="Delete"
                          buttonType="button"
                          actionBlock={handleDeleteTicket}
                        />
                      )}            
                    </Col>
                  </Row>
                  {/* Routing Section */}
                  <Row className="g-2">
                    <Col md={4}>
                      <label className="form-label"><strong>Status</strong></label>
                      <FormikSelectField
                        name="status"
                        value={values.status}
                        onChange={(name, value) => {
                              handleStatusChange(setFieldValue, value);
                            }}
                      >
                        {statusList.map((item) => (
                          <option key={item.value} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </FormikSelectField>
                      <ErrorMessage name="status" component="div" className="error-text" />
                    </Col>

                    <Col md={4}>
                      <label className="form-label"><strong>Admin Group</strong></label>
                      <FormikSelectField
                        name="adminGroup"
                        value={values.adminGroup}
                        onChange={(name, value) =>  handleAdminGroupChange({ target: { value } }, setFieldValue) }
                        placeholder="Select a user group"
                      >
                        <option value="">Select</option>
                        {adminGroup.map((admin) => ( <option key={admin.group_id} value={admin.group_id}> {admin.group_name} </option> ))}
                      </FormikSelectField>
                      <ErrorMessage name="adminGroup" component="div" className="error-text" />
                    </Col>

                    <Col md={4}>
                      <label className="form-label"><strong>Assigned To</strong></label>
                      <FormikSelectField
                        name="assignedTo"
                        value={values.assignedTo}
                        //onChange={(name, value) => setFieldValue(name, value)}
                        onChange={(field, selected ) => setFieldValue("assignedTo", selected || null)}
                        placeholder="Select an employee"
                        disabled={!values.adminGroup}
                      >
                        <option value= "" >Select</option>
                        {employees.map((emp) => ( <option key={emp.id} value={emp.id}> {emp.emp_name}{","} {emp.employee_id} </option> ))}
                      </FormikSelectField>
                      <ErrorMessage name="assignedTo" component="div" className="error-text" />
                    </Col>
                  </Row>
                  
                  {/* Requested / Category / Subcategory */}
                    <Row className="g-2 mt-2">
                      <Col md={4}>
                        <div className="d-flex align-items-center mb-1">
                          <label className="form-label me-2 mb-0">
                            <strong>Requested User</strong>
                          </label>
                          <a
                            href={`/employees/${ticketdetails?.requested_for}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Open Employee Profile"
                          >
                            <i className="fas fa-external-link-alt location-link-icon " ></i>
                          </a>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          value={values.requestedUser || ""}
                          readOnly
                        />
                          </Col>
                      {/* CATEGORY DROPDOWN */}
                      {filteredCategories && Array.isArray(filteredCategories) && filteredCategories.length > 0 && (
                        <Col md={4}>
                          <label className="form-label">
                            <strong>Category</strong>
                          </label>
                          <FormikSelectField
                            name="category"
                            value={values.category}
                            onChange={(name, value) => {
                              setFieldValue("category", value);
                              const selectedCat = filteredCategories.find( (cat) => cat.name === value );
                              setArticleID(selectedCat?.category_config_id || "");
                              setFieldValue("subcategory", ""); // reset subcategory
                            }}
                          //  placeholder="Select category"
                          >
                            {/* <option value="">Select Category</option> */}
                            {filteredCategories.map((cat) => (
                              <option key={cat.id} value={cat.name}>
                                {cat.name}
                              </option>
                            ))}
                          </FormikSelectField>
                          <ErrorMessage name="category" component="div" className="error-text" />
                        </Col>
                      )}

                      {/* SUBCATEGORY DROPDOWN */}
                      {values.category && (
                        <Col md={4}>
                          <label className="form-label">
                            <strong>Subcategory</strong>
                          </label>
                          <FormikSelectField
                                name="subcategory"
                                value={values.subcategory}
                                // onChange={(name, value) => {
                                //   setFieldValue(name, value);
                                  
                                //   const selectedCat = categoryconfig.data.find(c => c.id == values.category);
                                //   const selectedSub = selectedCat?.sub_category?.find(s => s.s_id == value);

                                //   if (selectedSub) {
                                //     setFieldValue("category_config_id", selectedSub.config_id);
                                //   }
                                // }}
                                // onChange={(name, value) => {
                                //     setFieldValue(name, value);
                                //     const selectedCat = categoryconfig.data.find(
                                //       (c) => c.name === values.category
                                //     );
                                //     const selectedSub = selectedCat?.sub_category?.find(
                                //       (s) => s.s_name === value
                                //     );
                                //     if (selectedSub) {
                                //       setFieldValue("category_config_id", selectedSub.config_id);
                                //     }
                                //   }}
                                onChange={(name, value) => {
                                  const selected = value;
                                  setFieldValue("subcategory", selected);

                                  // Find the selected category first
                                  const selectedCategory = filteredCategories?.find(
                                    (cat) => cat.name === values.category
                                  );

                                  // Find matching subcategory within the selected category only
                                  const matched = selectedCategory?.sub_category?.find(
                                    (sub) => sub.s_name === selected
                                  );

                                  if (matched) {
                                    // Set config id
                                    setFieldValue("categoryConfigId", matched.config_id);

                                    // Update admin group
                                    setFieldValue("adminGroup", matched.admin_group);
                                    dispatch(loadGroupByIDJobTitlesGetDataRequest(matched.admin_group));

                                    // Update assigned to
                                    setFieldValue("assignedTo", matched.assigned_to);
                                  }
                              }}



                              >
                            {/* <option value="">Select Subcategory</option> */}
                            {(() => {
                              const selectedCategory = filteredCategories?.find(
                                (cat) => cat.name === values.category
                              );

                              if (!selectedCategory || !Array.isArray(selectedCategory.sub_category)) {
                                return (
                                  <option disabled>
                                    {selectedCategory ? "No subcategories" : "Select category first"}
                                  </option>
                                );
                              }

                              return selectedCategory.sub_category.map((sub) => (
                                <option key={sub.s_id} value={sub.s_name} >
                                  {sub.s_name}
                                </option>
                              ));
                            })()}
                          </FormikSelectField>
                          <ErrorMessage name="subcategory" component="div" className="error-text" />
                        </Col>
                      )}
                    </Row>

                  {/* Divider line */}
                  <hr className="ticket-divider" />
                  {/* Ticket content area */}
                  <div className="ticket-content">
                    {currentTracker === 1 && (<TicketGeneral values={values} setFieldValue={setFieldValue} ticketdetails={ticketdetails} newMessageAttachments={newMessageAttachments} onDeleteAttachment={(ticketId, fileId) =>    dispatch(loadTicketAttachmentDeleteDataRequest(ticketId, fileId))} /> )}                    
                    {currentTracker === 2 && <TicketMessages values={values} setFieldValue={setFieldValue} messages={ticketdetails?.messages || []} internal_notes={ticketdetails?.internal_notes || []} />}
                    {currentTracker === 3 && <TicketHistory values={values} setFieldValue={setFieldValue} history={ticketdetails?.history || []} />}
                    {currentTracker === 4 && (<TicketSolution values={values} setFieldValue={setFieldValue} solution= {ticketdetails.solutions || []}/>)}
                    {currentTracker === 5 && (<TicketArticle values={values} setFieldValue={setFieldValue} articleID= {articleID} />)}
                  </div>
                </Form>
             ); }}
            </Formik>
          </Card.Body>
        </Card>
      </div>
      {/* Floating Action Button */}
      <button
        className="floating-action-button"
        onClick={() => setShowSidePanel(true)}
        title="Quick Actions"
      >
        <i className="far fa-lightbulb"></i>        
      </button>

      {/* Ticket Insights Side Panel */}
        <TicketInsights 
          show={showSidePanel} 
          onClose={() => setShowSidePanel(false)}
          insights={insights}
        />       
      {/* Send Mess Model */}

        <Formik
          initialValues={sendMessageInitialValues}
          enableReinitialize
          validationSchema={sendMessageValidationSchema}
          onSubmit={handleSendMessage}
          innerRef={sendMessageFormikRef}
        >
          {(formik) => {

            // Reusable close handler — resets form then closes
            const handleCloseModal = () => {
              formik.resetForm();
              setShowSendModal(false);
              setIsMinimized(false);
            };

            return (
              <>
                <Modal
                  show={showSendModal && !isMinimized}
                  onHide={handleCloseModal}
                  size="lg"
                  dialogClassName="send-message-modal"
                  backdrop="static"
                  keyboard={false}
                >
                  <Modal.Header>
                    <Modal.Title>Send Message</Modal.Title>
                    <div className="d-flex align-items-center gap-2">
                      <span
                        onClick={() => setIsMinimized(true)}
                        title="Minimize"
                        className="modal-minimize-btn"
                      >
                        &#8722;
                      </span>
                      <span
                        onClick={handleCloseModal}   // ← resets + closes
                        title="Close"
                        className="modal-close-btn"
                      >
                        &times;
                      </span>
                    </div>
                  </Modal.Header>
                  <Modal.Body>
                    <TicketSendMessage
                      formik={formik}
                      ticketdetails={ticketdetails}
                      setNewMessageAttachments={setNewMessageAttachments}
                      handleClose={handleCloseModal}  // ← Cancel button also resets
                    />
                  </Modal.Body>
                </Modal>

                {/* Minimized bar */}
                {showSendModal && isMinimized && (
                  <div
                    className="send-message-minimized-bar"
                    onClick={() => setIsMinimized(false)}
                    title="Click to restore"
                  >
                    <span>📨 Send Message</span>
                    <div className="d-flex gap-2 align-items-center">
                      <span title="Restore">&#9650;</span>
                      <span
                        title="Close"
                        className="send-message-minimized-close"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCloseModal();         // ← bar × also resets
                        }}
                      >
                        &times;
                      </span>
                    </div>
                  </div>
                )}
              </>
            );
          }}
        </Formik>  

      {/* Custom Confirm Modal for navigation */}
      <ConfirmModal
        show={showPrompt}
        handleClose={cancelNavigation}
        handleConfirm={confirmNavigation}
        title="Unsaved Changes"
        message="You have unsaved changes. Are you sure you want to leave?"
        confirmText="Leave"
        cancelText="Stay"
      />
      
      {/* Delete Modal */}
      <Modalpopup
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        actionTitle={ticketdetails?.ticket_number && ticketdetails?.title ? `${ticketdetails.ticket_number} - ${ticketdetails.title}` : TICKET_DETAILS}
        size="lg"
      >
        <p>Are you sure you want to delete this ticket?</p>

        <div className="d-flex justify-content-end gap-2 mt-3">
          <DefaultButton
            buttonClass="btn btn-secondary"
            buttonTitle="Cancel"
            buttonType="button"
            actionBlock={() => setShowDeleteModal(false)}
          />

          <DefaultButton
            buttonClass="btn btn-danger"
            buttonTitle="Delete"
            buttonType="button"
            actionBlock={confirmDeleteTicket}
          />
        </div>
      </Modalpopup>
      

      {/* Reopen Reason Modal */}
      <ReopenReasonModal
        show={showReopenReasonModal}
        handleClose={handleReopenReasonCancel}
        handleConfirm={handleReopenReasonConfirm}
      />

    </>
  );
};

export default TicketDetails;
